import React, { useEffect } from 'react';

import "./resume.styles.css";
import Footer from "../../components/footer/footer.component";

const AutoDownload = () => {
    /*useEffect(() => {
        const link = document.createElement('a');
        link.href = `${process.env.PUBLIC_URL}/resume.pdf`;
        link.download = 'pankajvyasresume.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, []);*/

    return (
      <div className="section">
        <div className="section resume-box">
            <p className="download-link"><a href={`${process.env.PUBLIC_URL}/resume.pdf`} download>
              <h1 className="download-title">Download Resume</h1> 
            </a></p>
        </div>
      </div>
    );
};

export default AutoDownload;
